export default {"src":"/_next/static/media/checklist.11cbcf5b.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};